import { render, staticRenderFns } from "./MenuSchool.vue?vue&type=template&id=75475fc0&scoped=true"
import script from "./MenuSchool.vue?vue&type=script&lang=js"
export * from "./MenuSchool.vue?vue&type=script&lang=js"
import style0 from "./MenuSchool.vue?vue&type=style&index=0&id=75475fc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75475fc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75475fc0')) {
      api.createRecord('75475fc0', component.options)
    } else {
      api.reload('75475fc0', component.options)
    }
    module.hot.accept("./MenuSchool.vue?vue&type=template&id=75475fc0&scoped=true", function () {
      api.rerender('75475fc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/MenuSchool.vue"
export default component.exports